import _toConsumableArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { AnimatedContainer, ANIMATION_TYPES, Button, Category, Divider } from '@miro-site/ui-foundation';
import { UserStatus } from '@miro-site/utils-helpers';
import { MenuItem } from './menu-item';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var getAnimationType = function getAnimationType(animated, isFirstLevel) {
  if (isFirstLevel && animated) {
    return ANIMATION_TYPES.NONE;
  }

  return isFirstLevel ? ANIMATION_TYPES.FADE_IN : ANIMATION_TYPES.SLIDE_IN_FADE_IN;
};

export var DrawerMenu = function DrawerMenu(_ref) {
  var _menu$children;

  var contactSalesLink = _ref.contactSalesLink,
      dashboardLink = _ref.dashboardLink,
      loginLink = _ref.loginLink,
      menu = _ref.menu,
      setCurrentMenuPath = _ref.setCurrentMenuPath,
      currentMenuPath = _ref.currentMenuPath,
      signupLink = _ref.signupLink,
      userStatus = _ref.userStatus;

  var _useState = useState(false),
      animated = _useState[0],
      setAnimated = _useState[1];

  var isFirstLevel = currentMenuPath.length === 0;
  var animationType = getAnimationType(animated, isFirstLevel);
  var animationDelay = 0;
  var isLoggedIn = userStatus === UserStatus.loggedIn;
  useEffect(function () {
    setTimeout(function () {
      /**
       * Once the drawer has been opened, we need to set this to true to prevent
       * the animation from running again unless the drawer has been closed
       */
      setAnimated(true);
    }, 500);
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: "d-flex flex-column h-100 justify-content-between",
    children: [/*#__PURE__*/_jsxs("ul", {
      className: "p-0 list-unstyled d-flex flex-column gap-300",
      children: [menu === null || menu === void 0 ? void 0 : (_menu$children = menu.children) === null || _menu$children === void 0 ? void 0 : _menu$children.map(function (node, nodeIndex) {
        if (isFirstLevel && node !== null && node !== void 0 && node.children) {
          return /*#__PURE__*/_jsx(MenuItem, {
            animationDelay: animationDelay++,
            animationType: animationType,
            href: node === null || node === void 0 ? void 0 : node.href,
            label: node.label,
            media: node === null || node === void 0 ? void 0 : node.media,
            onSelect: function onSelect() {
              setCurrentMenuPath([].concat(_toConsumableArray(currentMenuPath), [nodeIndex]));
            }
          }, node.label);
        }

        if (node !== null && node !== void 0 && node.children) {
          var _node$children;

          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [!!nodeIndex && /*#__PURE__*/_jsx(Divider, {
              className: "my-100",
              light: true
            }), /*#__PURE__*/_jsx(Category, {
              animationDelay: animationDelay++,
              animationType: animationType,
              className: "mb-n50",
              children: node.label
            }), node === null || node === void 0 ? void 0 : (_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.map(function (child, childIndex) {
              return /*#__PURE__*/_jsx(MenuItem, {
                animationDelay: animationDelay++,
                animationType: animationType,
                href: child === null || child === void 0 ? void 0 : child.href,
                label: child.label,
                media: child === null || child === void 0 ? void 0 : child.media,
                onSelect: function onSelect() {
                  setCurrentMenuPath([].concat(_toConsumableArray(currentMenuPath), [childIndex]));
                }
              }, child.label);
            })]
          });
        }

        return /*#__PURE__*/_jsx(MenuItem, {
          animationDelay: animationDelay++,
          animationType: animationType,
          href: node.href,
          label: node.label
        }, node.label);
      }), isFirstLevel && contactSalesLink && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Divider, {
          animationDelay: animationDelay++,
          animationType: animationType,
          className: "my-100",
          light: true
        }), /*#__PURE__*/_jsx(MenuItem, {
          animationDelay: animationDelay++,
          animationType: animationType,
          href: contactSalesLink === null || contactSalesLink === void 0 ? void 0 : contactSalesLink.href,
          label: contactSalesLink === null || contactSalesLink === void 0 ? void 0 : contactSalesLink.label
        }, contactSalesLink.label)]
      }), /*#__PURE__*/_jsx(Divider, {
        animationDelay: animationDelay++,
        animationType: animationType,
        className: "my-100",
        light: true
      })]
    }), isFirstLevel && /*#__PURE__*/_jsxs("div", {
      className: classNames('d-flex text-center flex-column gap-100'),
      children: [!isLoggedIn && loginLink && /*#__PURE__*/_jsx(AnimatedContainer, {
        className: "d-flex flex-column",
        delay: animationDelay++,
        animationType: animationType,
        children: /*#__PURE__*/_jsx(Button.Outline, {
          href: loginLink === null || loginLink === void 0 ? void 0 : loginLink.href,
          withStroke: true,
          children: loginLink === null || loginLink === void 0 ? void 0 : loginLink.label
        })
      }), !isLoggedIn && signupLink && /*#__PURE__*/_jsx(AnimatedContainer, {
        className: "d-flex flex-column",
        delay: animationDelay++,
        animationType: animationType,
        children: /*#__PURE__*/_jsx(Button.Primary, {
          href: signupLink === null || signupLink === void 0 ? void 0 : signupLink.href,
          withStroke: true,
          children: signupLink === null || signupLink === void 0 ? void 0 : signupLink.label
        })
      }), isLoggedIn && dashboardLink && /*#__PURE__*/_jsx(AnimatedContainer, {
        className: "d-flex flex-column",
        delay: animationDelay++,
        animationType: animationType,
        children: /*#__PURE__*/_jsx(Button.Primary, {
          href: dashboardLink === null || dashboardLink === void 0 ? void 0 : dashboardLink.href,
          withStroke: true,
          children: dashboardLink === null || dashboardLink === void 0 ? void 0 : dashboardLink.label
        })
      })]
    })]
  });
};